import { CLICK_TO_HIDE, CLICK_TO_SHOW } from 'Pages/GMS/ISR/ISRConstants';
import { HideEyeIcon, ShowEyeIcon } from 'assests/GmsIcons';
import React from 'react';

type ToggleEyeButtonProps = {
    isClicked: boolean;
    onClick: () => void;
  };

const ToggleEyeButton = ({isClicked, onClick}: ToggleEyeButtonProps) => {
    const handleClick = () => {
        onClick();
    };
    return (
        <div>
            <button data-testid="components-toggleeyebutton-button-1" className={`tw-text-[#747593] tw-text-sm tw-px-4 tw-py-2 tw-rounded focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-accent-hover`} onClick={handleClick}>
                {isClicked ? (
                    <div className='tw-flex tw-gap-2'>
                        <span className="ml-2">{CLICK_TO_HIDE}</span>
                        <ShowEyeIcon />
                    </div>
                ) : (
                    <div className='tw-flex tw-gap-2'>
                        <span className="ml-2">{CLICK_TO_SHOW}</span>
                        <HideEyeIcon />
                    </div>
                )}
            </button>
        </div>
    );
};

export default ToggleEyeButton;
